import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

// Import shared components, directives, and pipes here
import { SearchBoxComponent } from "../../components/search-box/search-box.component";
import { TableBoxComponent } from "../../components/table-box/table-box.component";
import { SelectComponent } from "../../components/select/select.component";
import { TosTableComponent } from "../../components/tos-table/tos-table.component";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SearchBoxComponent,
    TableBoxComponent,
    TosTableComponent,
    SelectComponent,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SearchBoxComponent,
    TableBoxComponent,
    TosTableComponent,
    SelectComponent
  ],
})
export class SharedModule {}
